import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { catchError, EMPTY, Observable } from 'rxjs';
import { UserApi } from '../../shared/services/api/user.api';
import { Beneficjent } from '../../shared/models/beneficjent';
import { HttpResponseService } from '../../core/services/http-error-response.service';

export const beneficiaryResolver: ResolveFn<Observable<Beneficjent>> = (
  route: ActivatedRouteSnapshot,
): Observable<Beneficjent> => {
  const userApi = inject(UserApi);
  const httpResponseService = inject(HttpResponseService);
  return userApi.getUser$().pipe(
    catchError((err) => {
      httpResponseService.showErrorMessage(
        err,
        'Wystąpił błąd podczas pobierania użytkownika.',
      );
      return EMPTY;
    }),
  );
};
